import React, { Fragment } from 'react'
import { useRouter } from 'next/router'
import { Dropdown } from 'semantic-ui-react'
import Link from 'next/link'

import useMediaQuery from 'hooks/useMediaQuery'
import _ from 'lodash'
import localization from '@web/containers/MyHealth/localization'
import { ChevronDown } from 'components/Icons'
import { useTheme } from 'contexts/ThemeProvider'
import themeStyles from './styles'

import {
  IconImmunizations as Immunizations,
  IconTestResults as TestResults,
  IconMedications as Medications,
  IconAllergies as Allergies,
  IconHealthConditions as HealthConditions,
  IconRadiology as Radiology,
  IconDocuments as Documents,
  IconMicrobiology as Microbiology
} from 'images/svg'

import { items as HEALTH_ITEMS } from 'containers/MyHealth/items.ehr'
import withLocalization from '@web/helpers/localizationUtils'

const MyHealthTabSelection = ({ t }) => {
  const { theme, isDark } = useTheme()
  const styles = themeStyles(theme)
  const icons = isCurr => {
    return {
      testResults: <TestResults style={styles.img(isCurr, isDark)} />,
      medications: <Medications style={styles.img(isCurr, isDark)} />,
      allergies: <Allergies style={styles.img(isCurr, isDark)} />,
      immunizations: <Immunizations style={styles.img(isCurr, isDark)} />,
      healthConditions: <HealthConditions style={styles.img(isCurr, isDark)} />,
      radiology: <Radiology style={styles.img(isCurr, isDark)} />,
      documents: <Documents style={styles.img(isCurr, isDark)} />,
      microbiology: <Microbiology style={styles.img(isCurr, isDark)} />
    }
  }
  const { isMobile, isTablet, isSmallMonitor } = useMediaQuery()
  const isMobileFlag = isMobile || isTablet || isSmallMonitor
  const router = useRouter()
  const { query = '' } = router
  const id = _.get(query, 'id', HEALTH_ITEMS[0].name)
  const getPath = id => {
    return `/myHealth?id=${id}`
  }
  const isCurr = value => {
    return _.isEqual(value, id)
  }
  const ITEM_LIST = HEALTH_ITEMS.map(item => {
    return {
      value: item.name,
      text: t(item.name),
      img: _.get(icons(isCurr(item.value)), item.name)
    }
  })
  const navigate = id => {
    router.push(getPath(id))
  }

  return (
    <Fragment>
      {!isMobileFlag && (
        <div style={styles.container(isMobileFlag)}>
          {ITEM_LIST.map(item => {
            return (
              <div
                key={item.value}
                style={styles.itemBox(isCurr(item.value))}
                onClick={() => navigate(item.value)}
              >
                <div style={styles.item()}>
                  <span style={styles.imgBox(isCurr(item.value))}>
                    {item.img}
                  </span>
                  <Link href={getPath(item.value)}>
                    <span style={styles.link(isCurr(item.value))}>
                      {item.text}
                    </span>
                  </Link>
                </div>
              </div>
            )
          })}
        </div>
      )}
      {isMobileFlag && (
        <div style={styles.container(isMobileFlag)}>
          <Dropdown
            upward={false}
            icon={<ChevronDown color={theme.primary} style={styles.icon} />}
            value={id}
            fluid
            selection
            style={styles.dropdown}
            options={ITEM_LIST}
            onChange={(_e, { value }) => navigate(value)}
            scrolling={false}
          />
        </div>
      )}
    </Fragment>
  )
}

export default withLocalization(MyHealthTabSelection, localization)
